module.exports = __webpack_public_path__ + "static/media/unlock-icon.87f6c36b.png";